import React from 'react'
import './ProjectCard.css';
import ProjectsData from './ProjectsData';
import ProjectCard from './ProjectCard';

const Projects = () => {
  return (
    <div className='work-container'>
        <h1 className='project-heading'>Projects</h1>
        <div className='project-container'>
            {ProjectsData.map((val, ind) => {
                return(
                    <ProjectCard 
                    key={ind}
                    imgsrc={val.imgsrc}
                    title={val.title}
                    text={val.text}
                    view={val.view} 
                    />
                )
            })}
        </div>
    </div>
  )
}

export default Projects